var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75h6.25v12.5H10v1.5h7.75V2.25H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1.94 10 4.81-4.81v4.06H13v1.5H6.75v4.06zm3.31 1.19V8.81L4.06 10z",
    clipRule: "evenodd"
  })));
};
export { SvgLogout as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDMuNzVIMTYuMjVWMTYuMjVIMTBWMTcuNzVIMTcuNzVWMi4yNUgxMFYzLjc1WiIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjkzOTM0IDkuOTk5OTFMNi43NTAxOSA1LjE4OTI2TDYuNzUwMTIgOS4yNUwxMyA5LjI1VjEwLjc1SDYuNzUwMUw2Ljc1MDAzIDE0LjgxMDVMMS45MzkzNCA5Ljk5OTkxWk01LjI1MDA5IDExLjE4OTNMNS4yNTAxMyA4LjgxMDUzTDQuMDYwNjkgOS45OTk5Mkw1LjI1MDA5IDExLjE4OTNaIiAvPgo8L3N2Zz4K";